module.exports = __webpack_public_path__ + "img/footer-6.e4ad5e5c.gif";